module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_03-3-f38fcccc130c9505524ec3f33d7beec9.png";